var $, PasswordChecker, PasswordErrorMessage, PasswordStengthMeter, PasswordValidator, loadZxcvbn;

$ = window.jQuery;

loadZxcvbn = require('./loadZxcvbn');

require('localmed-core');

$(function() {
  if ($('[data-password-checker]').length) {
    return loadZxcvbn();
  }
});

$(document).on('change.password-checker.data-api keyup.password-checker.data-api blur.password-checker.data-api', '[data-password-checker]', function(event) {
  return $(this).passwordChecker('check');
});

$.plugin('passwordChecker', {
  init: function() {
    this.disabled = false;
    this.inputWrapper = this.element.closest('.field-input');
    return this.submitButton = this.element.closest('form').find('input[type="submit"], button');
  },
  check: function() {
    var valid;
    if (!this.disabled) {
      this.checker || (this.checker = new PasswordChecker(this.element));
      valid = this.checker.checkPassword(this.element.val());
      this.inputWrapper.toggleClass('error-field', !valid);
      this.submitButton.prop('disabled', !valid);
      return valid;
    }
  },
  enable: function() {
    var ref;
    if (this.disabled) {
      this.disabled = false;
      if ((ref = this.checker) != null) {
        ref.enable();
      }
      if (this.element.val() !== '') {
        return this.check();
      }
    }
  },
  disable: function() {
    var ref;
    if (!this.disabled) {
      this.disabled = true;
      if ((ref = this.checker) != null) {
        ref.disable();
      }
      this.inputWrapper.toggleClass('error-field', false);
      return this.submitButton.prop('disabled', false);
    }
  },
  toggle: function(value) {
    if (value == null) {
      value = this.disabled;
    }
    if (value) {
      return this.enable();
    } else {
      return this.disable();
    }
  }
});

PasswordChecker = (function() {
  function PasswordChecker(input) {
    this.errorMessage = new PasswordErrorMessage('Invalid Password');
    this.strengthMeter = new PasswordStengthMeter();
    this.element = $('<div>', {
      "class": 'password-checker'
    }).append(this.strengthMeter.element).append(this.errorMessage.element);
    if (input != null) {
      input.after(this.element);
    }
  }

  PasswordChecker.prototype.checkPassword = function(password) {
    var error, error1, strength, validator;
    validator = new PasswordValidator(password);
    if (validator.isValid()) {
      try {
        strength = validator.getStrength();
        this.strengthMeter.setStrength(strength);
      } catch (error1) {
        error = error1;
        console.error(error);
      }
      this.element.removeClass('is-invalid', false);
      return true;
    } else {
      this.element.toggleClass('is-invalid', true);
      this.errorMessage.setErrors(validator.errors);
      return false;
    }
  };

  PasswordChecker.prototype.enable = function() {
    return this.element.toggleClass('is-disabled', false);
  };

  PasswordChecker.prototype.disable = function() {
    return this.element.toggleClass('is-disabled', true);
  };

  return PasswordChecker;

})();

PasswordErrorMessage = (function() {
  function PasswordErrorMessage(invalidMessage) {
    this.invalidMessage = invalidMessage;
    this.errorMessages = $('<ul>');
    this.element = $('<div>', {
      "class": 'password-checker-errors error-message'
    }).append("<p><strong>" + this.invalidMessage + "</strong></p>").append(this.errorMessages);
  }

  PasswordErrorMessage.prototype.setErrors = function(errors) {
    var error;
    return this.errorMessages.html(((function() {
      var i, len, results;
      results = [];
      for (i = 0, len = errors.length; i < len; i++) {
        error = errors[i];
        results.push("<li>" + error + "</li>");
      }
      return results;
    })()).join(''));
  };

  return PasswordErrorMessage;

})();

PasswordValidator = (function() {
  function PasswordValidator(password1) {
    this.password = password1;
  }

  PasswordValidator.prototype.isValid = function() {
    this.errors = [];
    this.validateLength();
    this.validateContent();
    return this.errors.length === 0;
  };

  PasswordValidator.prototype.getStrength = function() {
    var result;
    if (typeof zxcvbn === "undefined" || zxcvbn === null) {
      throw new Error('zxcvbn not loaded, password strength cannot be determined');
    }
    result = zxcvbn(this.password);
    return (result.score + 1) * 20;
  };

  PasswordValidator.prototype.validateLength = function() {
    if (this.password.length < 8) {
      return this.errors.push('Must be at least 8 characters');
    }
  };

  PasswordValidator.prototype.validateContent = function() {
    if (!(/\d/g.test(this.password) && /[a-z]/g.test(this.password))) {
      return this.errors.push('Must include at least 1 letter and 1 number');
    }
  };

  return PasswordValidator;

})();

PasswordStengthMeter = (function() {
  function PasswordStengthMeter() {
    this.progressBarElement = $('<div>', {
      "class": 'progress-bar'
    });
    this.progressElement = $('<div>', {
      "class": 'progress small-progress'
    }).append(this.progressBarElement);
    this.statusElement = $('<strong>');
    this.element = $('<div>', {
      "class": 'password-checker-strength is-disabled'
    }).append(this.progressElement).append($('<p>', {
      "class": 'small space-top'
    }).append($('<span>', {
      "class": 'muted'
    }).text('Password Strength: ')).append(this.statusElement));
  }

  PasswordStengthMeter.prototype.setStrength = function(value) {
    var percentValue, statusClass, statusText;
    if (value <= 40) {
      statusClass = 'error';
      statusText = 'Weak';
    } else if (value <= 60) {
      statusClass = 'warning';
      statusText = 'So-so';
    } else if (value <= 80) {
      statusClass = 'primary';
      statusText = 'Good';
    } else {
      statusClass = 'success';
      statusText = 'Strong';
    }
    percentValue = value + "%";
    this.statusElement.removeClass('error warning primary success').addClass(statusClass);
    this.progressElement.removeClass('error-progress warning-progress primary-progress success-progress').addClass(statusClass + "-progress");
    this.statusElement.text(statusText);
    this.progressBarElement.css({
      width: percentValue
    });
    return this.element.removeClass('is-disabled');
  };

  return PasswordStengthMeter;

})();
